import styled from 'styled-components';

interface StyledBaseSVGProps {
  width: number;
}

export const StyledBaseSVG = styled.svg<StyledBaseSVGProps>`
  width: ${({ width }) => width}px;
  display: block;
`;

interface BaseProps {
  tabIndex?: number;
}

export const BaseRect = styled.rect<BaseProps>`
  pointer-events: ${({ tabIndex }) => (tabIndex === 0 ? 'auto' : 'none')};
  cursor: ${({ tabIndex }) => (tabIndex === 0 ? 'pointer' : 'none')};

  &:focus {
    outline: none;
  }
`;
